{
	"description": "Entitlement template for product 9af73c36-bb77-41f8-9b11-2d20e9f74c44",
	"features": [
		{
			"featureId": "provided-allowances",
			"domain": "BILLING",
			"value": {
				"allowances": [
					{
						"reference": "allowance_automation-credits",
						"type": "ALLOWANCE",
						"config": {
							"usageKey": "automation-credits",
							"cycles": [
								{
									"schedule": "BILLING",
									"cycle": "MONTHLY",
									"amount": 1250
								},
								{
									"schedule": "BILLING",
									"cycle": "ANNUAL",
									"amount": 1250
								}
							],
							"isConsumer": false,
							"recipientEntity": "POOL"
						}
					}
				]
			}
		}
	]
}
